import { useEffect, useState } from 'react';
import { Toast, type ToastVariant } from '@//components/Toast';
import type { Toast as ToastProviderType } from '@//providers/ToastProvider';

const CLOSE_ANIMATION_MS = 200; // match CSS duration

interface ToastItemProps {
  toast: ToastProviderType;
  onRemove: (id: string) => void;
}

const ToastItem = ({ toast, onRemove }: ToastItemProps) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => {
        // Use view transition API for smooth removal
        if (document.startViewTransition) {
          document.startViewTransition(() => {
            onRemove(toast.id);
          });
        } else {
          onRemove(toast.id);
        }
      }, CLOSE_ANIMATION_MS);
      return () => clearTimeout(timeout);
    }
  }, [open, onRemove, toast.id]);

  return (
    <Toast
      open={open}
      title={toast.title}
      description={toast.description}
      variant={toast.type as ToastVariant}
      onClose={() => setOpen(false)}
      viewTransitionName={`toast-${toast.id}`}
      icon={toast.icon}
    />
  );
};

export default ToastItem;
